/*
 * Analog Theme
 *
 * Use this file to add custom Alpine code to the Analog Theme.  Keeping your custom
 * Javascript in this fill will make it easier to update Analog. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.events.js script import line near the bottom of the file.
 *
 */

// Below are example event listeners.  They listen for theme events that Analog
// fires in order to make it easier for you to add customizations.

window.addEventListener('theme:variant:change', (event) => {
  // Fires when variant is changed in a product form
  // You might use this to write a pre-order feature or a custom swatch feature.

  const variantId = event.detail.variantId;
  const sectionId = event.detail.sectionId;
  const optionElement = event.target;
  const sourceSection = optionElement.closest('.shopify-section');
  const sourceSectionId = sourceSection?.id?.replace('shopify-section-', '');

  if (sectionId !== sourceSectionId) return;

  // console.log('theme:variant:change', {
  //   variantId,
  //   optionElement,
  // });

  const isFromMainProductForm = optionElement.closest('.main-product');
  const isFromQuickviewProductForm = optionElement.closest('.product-quickview-drawer');

  if (isFromMainProductForm) {
    // Notify Smartrr of the variant change so its price display updates.
    // This theme fires 'theme:variant:change' but Smartrr expects 'variant:change',
    // so we call Smartrr's API directly to sync the widget state.
    const smartrrFieldset = document.querySelector('[data-smartrr-widget-purchase-options]');
    if (smartrrFieldset && variantId) {
      const productId = smartrrFieldset.getAttribute('data-smartrr-widget-purchase-options');
      const smartrrEntry = window.smartrrProductList?.[productId];

      // Smartrr populates .logic and/or .ui after app.js initialises — find whichever has the API
      const smartrr = [smartrrEntry?.logic, smartrrEntry?.ui, smartrrEntry].find(
        (obj) => obj && typeof obj.apiChangeVariant === 'function'
      );

      if (smartrr) {
        // Read the currently selected selling plan so we can reapply it after the variant swap
        const activeGroupInput = smartrrFieldset.querySelector('[data-smartrr-selling-plan-group-input]:checked');
        const groupId = activeGroupInput?.value || '';
        const planSelectEl = groupId
          ? smartrrFieldset.querySelector(`[data-smartrr-selling-plans-select="${groupId}"]`)
          : null;
        const planId = planSelectEl?.value ? Number(planSelectEl.value) : null;

        Promise.resolve()
          .then(() => smartrr.apiChangeVariant(Number(variantId)))
          .then(() => smartrr.apiSetupVariantAndGroup(Number(variantId)))
          .then(() => {
            if (planId && typeof smartrr.apiChangePlan === 'function') {
              return smartrr.apiChangePlan(planId);
            }
          })
          .catch((err) => console.error('Smartrr variant update error:', err));
      }
    }
  } else if (isFromQuickviewProductForm) {
    // Do something for the quickview product form
  }
});
